import BackgroundImage from "@pathwright/ui/src/components/background/BackgroundImage"
import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import CohortMembersControls from "@pathwright/web/src/modules/group/manage/CohortMembersControls"
import { ConnectStores } from "lib/core/store"
import pluralize from "pluralize"
import "./MemberListHeader.css"

const MemberListHeader = (props) => {
  const { resource, offering, onClose, seats_available, seats_filled } = props

  if (!offering) return null

  return (
    <header className="MemberListHeader">
      <BackgroundImage
        screensizeSelect={{
          sm: { roundedTop: false },
          md: { roundedTop: true }
        }}
        image={resource && resource.background_image_blurred_cdn}
      />
      <div className="MemberListHeader__content">
        <Button
          className="Card__Back"
          onClick={onClose}
          styleType="blank"
          inverted
        >
          <span>
            <Pathicon icon="x" />
          </span>
        </Button>
        <div className="MemberListHeader__action">
          <CohortMembersControls cohortId={offering.id} />
        </div>

        <div className="MemberListHeader__group">
          <Text.H3 inverted>{offering.name}</Text.H3>
          <Text.Body inverted>
            <span>
              <Pathicon icon="group" />
              <span> </span>
              {pluralize("learner", seats_filled, true)}
            </span>
            {((seats_available >= 0 && !offering.resource_license) ||
              (offering.resource_license &&
                offering.resource_license.seat_count > 0 &&
                !offering.resource_license.ignore_seat_count)) && (
              <span>{pluralize("seat", seats_available, true)} remaining</span>
            )}
          </Text.Body>
        </div>
      </div>
    </header>
  )
}

MemberListHeader.displayName = "MemberListHeader"

const mapStateToProps = (state, ownProps) => {
  const { resource, offering } = state.resourceStore.state

  const seats_available = state.resourceStore.request.seatsAvailable(offering)
  // TODO: show consistent number for people in a group platform-wide
  const seats_filled = offering && offering.seats_filled

  return _.assign(
    {},
    {
      resource,
      offering,
      seats_available,
      seats_filled
    },
    ownProps
  )
}

const stores = [
  { store: "resource", watch: ["resource", "offering", "section"] }
]

export default ConnectStores(MemberListHeader, stores, {}, mapStateToProps)
